import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import {
  baseStyles,
  TextTypes
} from "@streeteasy/design-system/deprecated/Typography/Typography";

/**
 * @deprecated Use @streeteasy/design-system/typography instead
 */
const Text = styled.p`
  ${baseStyles}
  color: ${({ type = "default" }) => TextTypes[type].color || colors.whaleGrey};
  font-size: ${({ type = "default" }) => TextTypes[type].fontSize};
  font-weight: ${({ type = "default" }) =>
    TextTypes[type].fontWeight || "normal"};
  line-height: ${({ type = "default" }) => TextTypes[type].lineHeight};
`;

export default Text;
